document.addEventListener('DOMContentLoaded', function () {
  initReveal();
  initCountUp();
  initGaleriaProducto();
  initVariantesProducto();
  initLogoNeon();
  initResenaCarrusel();
  initComoFuncionaModal();
  initDispositivosInteractivo();
});

function initDispositivosInteractivo() {
  var collage = document.querySelector('[data-mt-dispositivos]');
  if (!collage) return;
  var order = [
    collage.querySelector('.mt-disp-slot-main'),
    collage.querySelector('.mt-disp-slot-izq'),
    collage.querySelector('.mt-disp-slot-der')
  ].filter(Boolean);
  if (order.length < 2) return;
  var slots = ['mt-disp-slot-main', 'mt-disp-slot-izq', 'mt-disp-slot-der'];
  function aplicar() {
    order.forEach(function (item, i) {
      item.classList.remove('mt-disp-slot-main', 'mt-disp-slot-izq', 'mt-disp-slot-der');
      item.classList.add(slots[i]);
    });
  }
  order.forEach(function (item) {
    item.addEventListener('click', function () {
      var idx = order.indexOf(item);
      if (idx === 0) return;
      order.splice(idx, 1);
      order.unshift(item);
      aplicar();
    });
  });
}

function initComoFuncionaModal() {
  var abrirBtns = document.querySelectorAll('[data-mt-cf-abrir]');
  var overlay = document.querySelector('[data-mt-cf-overlay]');
  if (!abrirBtns.length || !overlay) return;
  var cerrarBtns = overlay.querySelectorAll('[data-mt-cf-cerrar]');
  function abrir() { overlay.hidden = false; }
  function cerrar() { overlay.hidden = true; }
  abrirBtns.forEach(function (btn) { btn.addEventListener('click', abrir); });
  cerrarBtns.forEach(function (btn) { btn.addEventListener('click', cerrar); });
  overlay.addEventListener('click', function (e) {
    if (e.target === overlay) cerrar();
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !overlay.hidden) cerrar();
  });
}

function initResenaCarrusel() {
  var wrap = document.querySelector('[data-mt-resena-carrusel]');
  if (!wrap) return;
  var track = wrap.querySelector('.mt-rc-track');
  var cards = wrap.querySelectorAll('.mt-rc-card');
  var total = cards.length;
  if (!track || total < 2) return;
  var index = 0;
  var contador = wrap.querySelector('[data-mt-rc-actual]');
  function ir(nuevo) {
    index = (nuevo + total) % total;
    track.style.transform = 'translateX(-' + (index * 100) + '%)';
    if (contador) contador.textContent = index + 1;
  }
  var prevBtn = wrap.querySelector('[data-mt-rc-prev]');
  var nextBtn = wrap.querySelector('[data-mt-rc-next]');
  if (prevBtn) prevBtn.addEventListener('click', function () { ir(index - 1); });
  if (nextBtn) nextBtn.addEventListener('click', function () { ir(index + 1); });
  setInterval(function () { ir(index + 1); }, 6000);
}

function initLogoNeon() {
  var els = document.querySelectorAll('.header__heading-link .h2, .footer .h2');
  if (!els.length) return;
  els.forEach(function (el) {
    if (el.dataset.mtLogoDone) return;
    var text = el.textContent.trim();
    if (!text) return;
    el.textContent = '';
    var span = document.createElement('span');
    span.className = 'mt-logo-neon';
    span.textContent = text;
    span.setAttribute('data-text', text);
    el.appendChild(span);
    el.dataset.mtLogoDone = 'true';
  });
}

function initReveal() {
  var els = document.querySelectorAll('.mt-reveal, .mt-reveal-scale');
  if (!els.length) return;
  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        var delay = entry.target.getAttribute('data-mt-delay') || 0;
        setTimeout(function () {
          entry.target.classList.add('mt-visible');
        }, parseInt(delay, 10));
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.15, rootMargin: '0px 0px -60px 0px' });
  els.forEach(function (el) { observer.observe(el); });
}

function initCountUp() {
  var els = document.querySelectorAll('.mt-countup');
  if (!els.length) return;
  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      var el = entry.target;
      var target = parseFloat(el.getAttribute('data-target') || '0');
      var suffix = el.getAttribute('data-suffix') || '';
      var duration = 1400;
      var start = null;
      function step(ts) {
        if (!start) start = ts;
        var progress = Math.min((ts - start) / duration, 1);
        var eased = 1 - Math.pow(1 - progress, 3);
        var value = target * eased;
        el.textContent = (Number.isInteger(target) ? Math.round(value) : value.toFixed(1)) + suffix;
        if (progress < 1) requestAnimationFrame(step);
      }
      requestAnimationFrame(step);
      observer.unobserve(el);
    });
  }, { threshold: 0.5 });
  els.forEach(function (el) { observer.observe(el); });
}

function initGaleriaProducto() {
  var wrap = document.querySelector('[data-mt-galeria]');
  if (!wrap) return;
  var main = wrap.querySelector('[data-mt-galeria-principal]');
  var thumbs = wrap.querySelectorAll('[data-mt-galeria-thumb]');
  thumbs.forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      var url = thumb.getAttribute('data-full');
      if (!url || !main) return;
      main.style.opacity = 0;
      setTimeout(function () {
        main.src = url;
        main.style.opacity = 1;
      }, 120);
      thumbs.forEach(function (t) { t.classList.remove('mt-thumb-activo'); });
      thumb.classList.add('mt-thumb-activo');
    });
  });
}

function initVariantesProducto() {
  var form = document.querySelector('[data-mt-producto-form]');
  if (!form) return;
  var dataEl = document.querySelector('[data-mt-variantes-json]');
  if (!dataEl) return;
  var variants = JSON.parse(dataEl.textContent);
  var selects = form.querySelectorAll('[data-mt-opcion]');
  var idInput = form.querySelector('input[name="id"]');
  var priceEl = document.querySelector('[data-mt-precio]');
  var compareEl = document.querySelector('[data-mt-precio-comparado]');
  var addBtn = form.querySelector('[data-mt-add-btn]');

  function moneyFormat(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function currentSelection() {
    var vals = [];
    selects.forEach(function (s) { vals.push(s.value); });
    return vals;
  }

  function findVariant() {
    var vals = currentSelection();
    return variants.find(function (v) {
      return v.options.every(function (opt, i) { return opt === vals[i]; });
    });
  }

  function update() {
    var variant = findVariant();
    if (!variant) return;
    idInput.value = variant.id;
    if (priceEl) priceEl.textContent = moneyFormat(variant.price);
    if (compareEl) {
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        compareEl.textContent = moneyFormat(variant.compare_at_price);
        compareEl.style.display = '';
      } else {
        compareEl.style.display = 'none';
      }
    }
    if (addBtn) {
      if (variant.available) {
        addBtn.disabled = false;
        addBtn.textContent = addBtn.getAttribute('data-texto-disponible');
      } else {
        addBtn.disabled = true;
        addBtn.textContent = addBtn.getAttribute('data-texto-agotado');
      }
    }
  }

  selects.forEach(function (s) { s.addEventListener('change', update); });
  update();
}
